/**
 * ModerationNotice - the fixed top-center toast (moderation actions, lobby
 * arrivals, follow errors). React port of showModerationNotice: single
 * replacing toast, blue for info / red for errors, 300ms fade-out after the
 * store clears it (the component holds the last notice through the fade).
 */
import { useEffect, useState } from 'react';
import { useStore } from 'zustand';
import { hudStore } from '../../state/hudStore';
import type { HudNotice } from '../../state/hudStore';

const FADE_MS = 300;

export function ModerationNotice() {
  const notice = useStore(hudStore, (s) => s.notice);
  const [shown, setShown] = useState<HudNotice | null>(notice);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (notice) {
      setShown(notice);
      setFading(false);
      return;
    }
    // Store cleared: keep the last text rendered through the fade.
    setFading(true);
    const t = setTimeout(() => setShown(null), FADE_MS);
    return () => clearTimeout(t);
  }, [notice]);

  if (!shown) return null;

  return (
    <div
      id="moderation-notice"
      style={{
        position: 'fixed',
        top: '24px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#fff',
        padding: '10px 22px',
        borderRadius: '10px',
        zIndex: 10001,
        fontFamily: 'sans-serif',
        fontSize: '15px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.4)',
        transition: 'opacity 0.3s',
        pointerEvents: 'none',
        background: shown.isError ? 'rgba(216,49,47,0.95)' : 'rgba(25,118,210,0.95)',
        opacity: fading ? 0 : 1,
      }}
    >
      {shown.text}
    </div>
  );
}
